import React from 'react';

interface AIThinkingIndicatorProps {
    currentLanguage?: string;
    isSimple?: boolean; // 简单模式：用于非正式对话
    status?: 'assessing' | 'searching' | 'analyzing' | 'answering'; // 后端状态
}

// 状态映射到显示文本
const STATUS_MESSAGES: Record<string, Record<string, string>> = {
    'zh-CN': {
        assessing: '评估查询...',
        searching: '检索相关信息...',
        analyzing: '分析中...',
        answering: '生成回答...',
        default: '处理中...',
    },
    'en-US': {
        assessing: 'Assessing query...',
        searching: 'Searching for relevant information...',
        analyzing: 'Analyzing...',
        answering: 'Answering...',
        default: 'Working...',
    },
};

// 获取语言对应的消息
const getStatusMessage = (lang: string, status?: string): string => {
    const langKey = lang.startsWith('zh') ? 'zh-CN' : 'en-US';
    const messages = STATUS_MESSAGES[langKey];

    if (status && messages[status]) {
        return messages[status];
    }
    return messages.default;
};

const AIThinkingIndicator: React.FC<AIThinkingIndicatorProps> = ({
    currentLanguage = 'en-US',
    isSimple = false,
    status
}) => {
    // 获取当前状态的显示文本
    const statusText = getStatusMessage(currentLanguage, status);

    // 单一步骤显示 - Harvey AI 风格
    return (
        <div className="flex items-center gap-2 py-2 px-1">
            {/* 旋转加载指示器 */}
            <div className="w-4 h-4 flex items-center justify-center">
                <div className="w-3 h-3 rounded-full border-2 border-gray-400 border-t-transparent animate-spin" />
            </div>

            {/* 状态文字 */}
            <span className="text-sm text-gray-600 font-medium">
                {statusText}
            </span>
        </div>
    );
};

export default AIThinkingIndicator;
